type MatchableCandidate = {
  candidateProfileId: string;
  atsCandidateId?: string | null;
};

type JobApplication = {
  candidateProfileId: string;
  atsCandidateId?: string | null;
};

/**
 * Of the given candidates, returns the profile ids that are already associated
 * with a job's applications — matching on candidateProfileId OR atsCandidateId
 * (the latter catches the same person carrying a duplicate profile).
 */
export const getAssociatedCandidateProfileIds = (
  applications: JobApplication[],
  candidates: MatchableCandidate[]
): string[] => {
  const jobProfileIds = new Set(
    applications.map((application) => application.candidateProfileId)
  );
  const jobAtsCandidateIds = new Set(
    applications
      .map((application) => application.atsCandidateId)
      .filter((atsCandidateId): atsCandidateId is string =>
        Boolean(atsCandidateId)
      )
  );

  return candidates
    .filter(
      (candidate) =>
        jobProfileIds.has(candidate.candidateProfileId) ||
        (!!candidate.atsCandidateId &&
          jobAtsCandidateIds.has(candidate.atsCandidateId))
    )
    .map((candidate) => candidate.candidateProfileId);
};
